import { API_JWT_BASE_URL } from '../http'

export const SEARCH_ALERTS_API = `${API_JWT_BASE_URL}/Alerts`
export const SEARCH_DISMISS_DEVICE_VALUE_CONFLICT_API = `${API_JWT_BASE_URL}/Alerts/DismissDeviceValuesConflict/`
export const SEARCH_DISMISS_UNKNOWN_DEVICE_REGISTRATION_API = `${API_JWT_BASE_URL}/Alerts/DismissUnknownDeviceRegistration/`

export const ALERTS_QUERY_KEYS = {
  SEARCH_ALERTS_API: 'SEARCH_ALERTS_API',
  GET_ALL_ALERTS: 'GET_ALL_ALERTS'
}
